import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';
import { AdminService } from '../../admin.service';

@Component({
    selector: 'app-admin-elements',
    templateUrl: './admin-elements.component.html',
    styleUrls: ['./admin-elements.component.scss'],
    standalone: false
})
export class AdminElementsComponent extends AdminActionsDirective {
    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }

    get showLoadingIndicator(): boolean {
        return (
            (this.isStandardView && !this.data) ||
            (this.isStandardView &&
                this.selectedItem &&
                Object.keys(this.selectedItem).length === 1 &&
                !!this.selectedItem.id) ||
            (!this.isStandardView &&
                this.selectedItem &&
                Object.keys(this.selectedItem).length === 1 &&
                !!this.selectedItem.id)
        );
    }
}
